import API_CALL from 'services/API';
const path = 'locations/';

export const ServiceLocations = {

  // List comuni
  listComuni: async ({
    pagination = false,
    paginationParams = {},
    expand = '',
    search = null,
  }) => {
    let params = {
      pagination,
      ...paginationParams,
      expand,
      ...search,
    };
    return API_CALL({
      url: path + 'comune',
      params: params,
    }).then((result) => {
      let data = [];
      if (result.pagination) {
        data = result.data;
      } else {
        data = result;
      }

      return {
        data,
        pagination: result.pagination || {},
      };
    });
  },

  // List comuni
  listRegioni: async ({
    pagination = false,
    paginationParams = {},
    expand = '',
    search = null,
  }) => {
    let params = {
      pagination,
      ...paginationParams,
      expand,
      ...search,
    };
    return API_CALL({
      url: path + 'regione',
      params: params,
    }).then((result) => {
      let data = [];
      if (result.pagination) {
        data = result.data;
      } else {
        data = result;
      }

      return {
        data,
        pagination: result.pagination || {},
      };
    });
  },

};

export default ServiceLocations;
